"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaloSpinnerWithText = void 0;
var react_1 = __importDefault(require("react"));
require("./HaloSpinnerWithText.scss");
var HaloSpinnerWithText = function (props) { return (react_1.default.createElement("div", { className: "halo-spinner" },
    react_1.default.createElement("span", { className: "fa-stack" },
        react_1.default.createElement("i", { className: "fa fa-circle-notch fa-spin fa-stack-2x has-text-info" }),
        react_1.default.createElement("strong", { className: "fa-stack-1x has-text-white" }, props.value)))); };
exports.HaloSpinnerWithText = HaloSpinnerWithText;
